import { useSyncExternalStore } from 'react'
import {
  getWorkspaceSessionSnapshot,
  subscribeWorkspaceSession,
} from '@/lib/session/workspace-session'

/** React observes the same account/access runtime used by background commands. */
export function useWorkspaceSession() {
  return useSyncExternalStore(
    subscribeWorkspaceSession,
    getWorkspaceSessionSnapshot,
    getWorkspaceSessionSnapshot,
  )
}
